import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";

import {
  geReflectionGemStyle,
  getTextColorByMood,
} from "../../mood/MoodsHelper";
import AppTheme from "../../../AppTheme";
import appStyles from "../../../../appStyles";

export default function JournalIcon(props) {
  const { mood, style } = props;

  const fillColor = props.fillColor || AppTheme.DEFAULT_COLOR;
  const color = getTextColorByMood(mood) || fillColor;
  const width = props.width || 16;
  const height = props.height || 16;

  const journalStyle = mood
    ? {
        ...geReflectionGemStyle(mood),
        width: 32,
        height: 32,
      }
    : {};

  return (
    <TouchableOpacity {...props} style={[appStyles.iconContainer, style]}>
      <View style={journalStyle}>
        <Svg
          width={width}
          height={height}
          viewBox="-2 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M27.5523 7.48152C27.2165 7.06877 26.7307 6.80599 26.2015 6.75078C25.6723 6.69558 25.1427 6.85245 24.7289 7.18702L12.68 16.9568C12.5713 17.0393 12.4872 17.15 12.4368 17.2769L11.1563 20.4011C11.1365 20.4505 11.129 20.504 11.1346 20.5569C11.1402 20.6098 11.1586 20.6606 11.1882 20.7048C11.2179 20.749 11.2579 20.7852 11.3048 20.8104C11.3517 20.8356 11.404 20.8489 11.4572 20.8493H11.5148L14.8376 20.2539C14.971 20.2292 15.0964 20.1721 15.2025 20.0874L27.2578 10.3113C27.671 9.97433 27.9339 9.48748 27.9891 8.95719C28.0443 8.4269 27.8872 7.89634 27.5523 7.48152Z"
            fill={color}
          />
          <Path
            d="M19.1271 19.0631V22.6291C19.1305 22.8241 19.0951 23.0178 19.023 23.199C18.951 23.3802 18.8436 23.5453 18.7072 23.6846C18.5708 23.824 18.4081 23.9349 18.2285 24.0109C18.0489 24.0868 17.856 24.1264 17.661 24.1272H7.82725C7.43841 24.1272 7.0655 23.9727 6.79056 23.6978C6.51561 23.4228 6.36115 23.0499 6.36115 22.6611V7.82725C6.3603 7.63448 6.39764 7.44345 6.47102 7.26519C6.5444 7.08693 6.65236 6.92498 6.78867 6.78867C6.92498 6.65236 7.08694 6.5444 7.26519 6.47102C7.44345 6.39764 7.63448 6.3603 7.82725 6.36115H17.661C18.0498 6.36115 18.4227 6.51561 18.6977 6.79056C18.9726 7.0655 19.1271 7.43841 19.1271 7.82725V9.56224L22.3922 6.91814C22.1823 5.81678 21.595 4.82303 20.7315 4.10791C19.868 3.39279 18.7822 3.00101 17.661 3H7.82725C6.5475 3.00169 5.32066 3.51082 4.41574 4.41574C3.51082 5.32066 3.00169 6.5475 3 7.82725L3 22.6291C3.00169 23.9088 3.51082 25.1357 4.41574 26.0406C5.32066 26.9455 6.5475 27.4546 7.82725 27.4563H17.661C18.9407 27.4546 20.1676 26.9455 21.0725 26.0406C21.9774 25.1357 22.4866 23.9088 22.4882 22.6291V16.3421L19.1271 19.0631Z"
            fill={color}
          />
        </Svg>
      </View>
    </TouchableOpacity>
  );
}
